'use client';

import { useEffect, useState } from 'react';

const STORAGE_KEY = 'enqdigital_cookie_consent';
// LGPD nao fixa um prazo de validade para o aceite de cookies (diferente do
// GDPR, onde reguladores europeus recomendam 6-12 meses) - usamos 1 semana
// por escolha propria, para manter o consentimento sempre recente.
const CONSENT_TTL_MS = 7 * 24 * 60 * 60 * 1000;

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      const raw = window.localStorage.getItem(STORAGE_KEY);
      const acceptedAt = raw ? Number(JSON.parse(raw).acceptedAt) : NaN;
      const expired = !Number.isFinite(acceptedAt) || Date.now() - acceptedAt > CONSENT_TTL_MS;
      if (expired) {
        setVisible(true);
      }
    } catch {
      setVisible(true);
    }
  }, []);

  const accept = () => {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify({ acceptedAt: Date.now() }));
    } catch {
      // localStorage indisponível; apenas oculta o aviso nesta sessão
    }
    setVisible(false);
  };

  if (!visible) {
    return null;
  }

  return (
    <div
      id="cookie-consent-banner"
      role="dialog"
      aria-label="Aviso de cookies"
      style={{
        position: 'fixed',
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 100,
        backgroundColor: '#000000',
        color: '#ffffff',
        borderTop: '1px solid rgba(255,255,255,0.15)',
      }}>
      <div
        className="container-site"
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: '16px',
          padding: '16px 24px',
        }}>
        <p style={{ fontSize: '13px', color: '#d1d1d1', margin: 0, flex: '1 1 320px' }}>
          Utilizamos cookies para melhorar sua experiência de navegação e para fins estatísticos. Ao continuar navegando, você concorda com nossa{' '}
          <a href="/politica-de-privacidade" style={{ color: '#1a9fff', textDecoration: 'underline' }}>
            Política de Privacidade e Termo de Uso de Cookies
          </a>
          .
        </p>
        <button
          onClick={accept}
          style={{
            backgroundColor: '#1a9fff',
            color: '#ffffff',
            fontSize: '13px',
            fontWeight: 600,
            padding: '10px 24px',
            borderRadius: '6px',
            border: 'none',
            cursor: 'pointer',
            flexShrink: 0,
          }}>
          Aceitar
        </button>
      </div>
    </div>
  );
}
